<template>
  <div class="d-flex justify-content-center">
    <div class="spinner-border justify-content-center" role="status">
      <span class="visually-hidden">{{ $t('common.loading') }}</span>
    </div>
  </div>
</template>